import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from '@jisr-hr/design-system'

const EmployeeComponent = ({ checked, employee = {}, onClick }) => (
  <div
    className="jisr-eligible-people__employee"
    onClick={() => onClick(employee)}
    data-testid={`check-employee-${employee.id}`}
  >
    <Checkbox checked={checked} />
    <div className="jisr-eligible-people__employee-img">
      <img
        src={employee.avatar}
        alt=""
      />
    </div>
    <div>
      <h4>
        {employee.code}, {employee.name_i18n}
      </h4>
      <small>{employee.job_title_i18n}</small>
    </div>
  </div>
)

EmployeeComponent.propTypes = {
  checked: PropTypes.bool,
  employee: PropTypes.shape(),
  onClick: PropTypes.func,
}

export default EmployeeComponent
